module.exports = __webpack_public_path__ + "img/pic2.81abc75d.png";